import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class PNLTransactionReportUseCase extends BaseUseCase {
    constructor(pnlReportRepo) {
        super();
        this.pnlReportRepo = pnlReportRepo;
    }
    async fetchResult(requestData) {
        const pnlReportData = await this.pnlReportRepo.getPNLTransactionData(requestData);
        return pnlReportData;
    }
}
export default PNLTransactionReportUseCase;
